import React from 'react';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import style from './propertyData.module.scss';
import ImageNext from '@/components/shared/ImageNext';

function PropertyData({
  picture,
  address,
  location,
  entityType = 'property',
  showDevelopmentIcon = true,
  ...rest
}) {
  const renderImage = () =>
    picture ? (
      <ImageNext
        className={style.propertyDataImage}
        src={picture}
        alt="property-image"
        width={87}
        height={58}
      />
    ) : (
      <Box className={style.noImageWrapper}>
        <Icon icon="icon-propiedades" />
      </Box>
    );

  const renderDevelopmentIcon = () => (
    <Box className={style.developmentIconWrapper}>
      <Icon className={style.developmentIcon} icon="icon-emprendimientos" />
    </Box>
  );

  return (
    <Box className={style.propertyDataContainer} {...rest}>
      <Box className={style.imageContainer}>
        {entityType === 'development' &&
          showDevelopmentIcon &&
          renderDevelopmentIcon()}
        {renderImage()}
      </Box>
      <Box className={style.propertyDataText}>
        <Text className={style.address}>{address}</Text>
        <Text className={style.location}>{location}</Text>
      </Box>
    </Box>
  );
}

export default PropertyData;
